<template>
  <section class="layout-container">
    <div class="row form-container">
      <!-- <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 right-side" v-if="is_screen_xs">
        <q-img src="/images/auth/reset-pssword.webp"></q-img>
      </div> -->

      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 left-side">
        <h3 class="title">
          <app-i18n code="auth.resetPassword"></app-i18n>
        </h3>
        <h5 class="message">
          <app-i18n code="auth.resetMessage"></app-i18n>
          <!-- <app-i18n :code="email"></app-i18n> -->
        </h5>

        <q-form :model="model" @submit.prevent.stop="handleResetPassword" class="form ProfileForm" ref="form">
          <q-input :dense="is_screen_xs || is_screen_sm" standout no-error-icon bg-color="Black-13" color="teal"
            class="q-mb-xs auth_field_input" v-model="newPassword" :type="isPwd ? 'password' : 'text'"
            :placeholder="i18n('auth.newPassword')" lazy-rules
            :rules="[ val => val && val.length > 0 || 'Enter your password']">
            <!-- :label="i18n('auth.authResetPassword')" -->
            <template v-slot:append>
              <q-icon size="1.25rem" :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer"
                @click="isPwd = !isPwd" />
            </template>
          </q-input>

          <q-input :dense="is_screen_xs || is_labtop" standout no-error-icon bg-color="Black-13" color="white"
            class="q-mb-xs auth_field_input" v-model="confirmPassword" :type="isConfirmPwd ? 'password' : 'text'"
            :placeholder="i18n('auth.placeholder.confirm')" ref="confirmPassword" lazy-rules :rules="[ 
              val => val !== null && val !== '' || i18n('auth.error.confirmRequired'),
              val => val == newPassword || i18n('auth.error.confirmNotMatched'),
            ]">
            <template v-slot:append>
              <q-icon size="1.25rem" :name="isConfirmPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer"
                @click="isConfirmPwd = !isConfirmPwd" />
            </template>
          </q-input>

          <div class="row">
            <div class="col-12 q-px-none">
              <q-btn flat no-caps :label="i18n('common.done')" :loading="loading" type="submit" text-color="white"
                class="btn bg-Pelorous full-width weight-bold radius-6">
                <!-- :style="model[fields.email.name] ? 'background: #36B1BF; color: #FFFFFF;' : 'background: #f7fdfd; color: #000000;'" -->
                <template v-slot:loading>
                  <q-spinner-ios size="sm" />
                </template>
              </q-btn>
            </div>
          </div>
        </q-form>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 right-side" v-if="!is_screen_xs">
        <q-img src="/images/auth/reset-pssword.webp"></q-img>
      </div>
    </div>


  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { i18n } from '@/i18n';
import firebase from 'firebase/app';
import 'firebase/auth';

import { UserModel } from '@/modules/auth/user-model';
const { fields } = UserModel;

export default {
  name: 'app-reset-password-page',
  props: {
    actionCode: {
      type: String,
      required: true,
    },
    continueUrl: {
      type: String,
      required: false,
    },
    lang: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      email: undefined,
      isPwd: true,
      newPassword: undefined,
      isConfirmPwd: true,
      confirmPassword: undefined,
      model: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      // loading: 'auth/loadingPasswordResetEmail',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
      menuCollapsed: 'layout/menuCollapsed',
      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
    }),

    fields() {
      return fields;
    },
    isRTL() {
      // return localStorage.getItem('language') == 'ar'
      return this.currentLanguageCode == 'ar';
    },
  },

  async mounted() {
    // Verify the password reset code is valid.
    let accountEmail = ''
    accountEmail = await firebase.auth().verifyPasswordResetCode(this.actionCode)
    // .then((email) => {
    //   this.accountEmail = email;
    //   console.log('accountEmail = ', accountEmail);
    // })
    // .catch((error) => {
    //     console.log(error);
    //     // Invalid or expired action code. Ask user to try to reset the password again.
    // });
    console.log('accountEmail = ', accountEmail);
    this.email = accountEmail
  },
  methods: {
    ...mapActions({
      // doSendPasswordResetEmail: 'auth/doSendPasswordResetEmail',
    }),
    i18n(key, args) {
      return this.$t(key, args);
    },
    async handleResetPassword() {
      debugger
      try {
        // Save the new password.
        this.loading = true
        const resp = await firebase.auth().confirmPasswordReset(this.actionCode, this.newPassword)
        console.log(resp);
        // Password reset has been confirmed and new password updated.

        // TODO: Display a link back to the app, or sign-in the user directly
        // if the page belongs to the same domain as the app:
        // auth.signInWithEmailAndPassword(accountEmail, newPassword);

        // TODO: If a continue URL is available, display a button which on
        // click redirects the user back to the app via continueUrl with
        // additional state determined from that URL's parameters.
      } catch (error) {
        console.log(error);
        // Error occurred during confirmation. The code might have expired or the password is too weak.
      }

      this.loading = false
    },
    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      await this.doSendPasswordResetEmail(this.model.email);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  padding-top: 150px !important;
  padding-bottom: 90px !important;
}

.left-side {
  padding-left: 0 !important;
  padding-right: 65px !important;

  .title {
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 50px !important;
    line-height: 75px !important;
    display: flex !important;
    align-items: center !important;
    color: #da3b30 !important;
    margin-bottom: 38px !important;
  }

  .message {
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 25px !important;
    line-height: 50px !important;
    display: flex !important;
    align-items: center !important;
    text-transform: capitalize !important;
    color: #000000 !important;
    margin-bottom: 24px !important;
  }
}

.right-side {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding-left: 65px !important;
  padding-right: 0 !important;
}

.btn {
  text-transform: capitalize;
  font-style: normal !important;
  font-size: 20px;
  line-height: 37px;
}
</style>

<style lang="scss" scoped>
@media (max-width: 1440px) {
  .footer-top {
    padding-top: calc(30px + (47 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
    padding-bottom: calc(30px + (54 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .form-container {
    padding-top: calc(30px + (150 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
    padding-bottom: calc(30px + (90 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .left-side {
    padding-right: calc(30px + (65 - 30) * ((100vw - 320px) / (1440 - 320))) !important;

    .title {
      font-size: calc(20px + (50 - 20) * ((100vw - 320px) / (1440 - 320))) !important;
      line-height: calc(30px + (75 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
      margin-bottom: calc(15px + (38 - 15) * ((100vw - 320px) / (1440 - 320))) !important;
    }

    .message {
      font-size: calc(16px + (25 - 16) * ((100vw - 320px) / (1440 - 320))) !important;
      line-height: calc(20px + (50 - 20) * ((100vw - 320px) / (1440 - 320))) !important;
      margin-bottom: calc(18px + (24 - 18) * ((100vw - 320px) / (1440 - 320))) !important;
    }
  }

  .right-side {
    padding-left: calc(30px + (65 - 30) * ((100vw - 320px) / (1440 - 320))) !important;
  }

  .btn {
    font-size: calc(14px + (20 - 14) * ((100vw - 320px) / (1440 - 320))) !important;
    line-height: 37px;
  }
}

@media (max-width: 599px) {
  .left-side {
    padding-right: 0 !important;
  }

  .right-side {
    padding-left: 0 !important;
  }
}
</style>


